import { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { Modal, Button, Form } from 'react-bootstrap';
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Footer from "./Footer";
import Header from "./Header";
import PlaneIco from './assets/img/PlaneIco.png';
import TwoTickets from './assets/img/TwoTickets.png';
import Travelator from './assets/img/Travelator.png';
import Traveler from './assets/img/Traveler.png';
import Suitcase from './assets/img/Suitcase.png';
import LOWPRICECALENDER from './assets/img/LOWPRICECALENDER.png';
import QRImg from './assets/img/QRImg.png';
import giftImg from './assets/img/giftImg.png';

const ManageBookingCancel = () => {
    const [isClosed, setIsClosed] = useState(false);
    const [showCancelBooking, setShowCancelBooking] = useState(false);
    const [showDisclaimer, setShowDisclaimer] = useState(false);
    const [showCancelBookingAuth, setShowCancelBookingAuth] = useState(false);
    const [showProceedToCancel, setShowProceedToCancel] = useState(false);
    const [show, setShow] = useState(false);

    const handleToggle = () => {
        setIsClosed(!isClosed);
    };

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const handleDisclaimerClose = () => setShowDisclaimer(false);
    const handleDisclaimerShow = () => setShowDisclaimer(true);
    const handleCancelAuthClose = () => setShowCancelBookingAuth(false);
    const handleCancelAuthShow = () => {
        setShowDisclaimer(false);
        setShowCancelBookingAuth(true);
    };
    const handleProceedToCancelClose = () => setShowProceedToCancel(false);
    const handleProceedToCancelShow = () => {
        setShowCancelBookingAuth(false);
        setShowProceedToCancel(true);
    };

    return (
        <>
            <Header></Header>
            <div className="mainContent">
                <div className="digitalTicketWrap flightReservWrap manageBookingWrap">
                    <div className="container-fluid">
                        <div className="row justify-content-center">
                            <div className="col-md-11">
                                <div className="titleWrap">
                                    <h2>Manage Booking</h2>
                                </div>
                            </div>
                        </div>
                        <div className="row justify-content-center">
                            <div className="col-md-9">
                                <div className="manageBookTopTxt">
                                    <p>Below are all the information regarding the flights that are currently on your itinerary<a href="#">.....more</a></p>
                                </div>
                                <div className="manageBookBox cancelBookingBoxWrap">
                                    <div className="ticketBox">
                                        <div className="leftWraps">
                                            <div className="topTTl">
                                                <h2>Departure Summary</h2>
                                            </div>
                                            <div className="topTtlWrap">
                                                <div className="title">
                                                    <div className="icoWrap"></div>
                                                    <h2>ABC Airline</h2>
                                                </div>
                                                <h6 className="note">Non-refundable</h6>
                                                <p className="classTxt">Travel Class: <span>Economy</span></p>
                                            </div>
                                            <div className="trvelTicWrap">
                                                <div className="leftWrap">
                                                    <ul>
                                                        <li>
                                                            <div className="items">
                                                                <h3>BOM</h3>
                                                                <h5>14.50</h5>
                                                                <p>Sun, 29 Jan 2023</p>
                                                                <p>Maharashtra,India</p>
                                                                <p>Terminal - 2, Gate - 25</p>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div className="items">
                                                                <h4>9hr 50min</h4>
                                                                <div className="planeIcoWrap">
                                                                    <img src={PlaneIco} className="img-fluid" alt=""/>
                                                                </div>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div className="items">
                                                                <h3>GOA</h3>
                                                                <h5>14.50</h5>
                                                                <p>Sun, 29 Jan 2023</p>
                                                                <p>Goa, India</p>
                                                                <p>Terminal - 2, Gate - 25</p>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div className="rightWrap">
                                                    <ul>
                                                        <li>
                                                            <p>Buggage</p>
                                                            <h3>ADULT</h3>
                                                        </li>
                                                        <li>
                                                            <p>Check-in</p>
                                                            <h3>23Kgs (1 Piece * 23Kgs)</h3>
                                                        </li>
                                                        <li>
                                                            <p>Cabin</p>
                                                            <h3>7Kgs (1 Piece * 7kgs)</h3>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className="ticketinfoWrap">
                                                <ul>
                                                    <li>
                                                        <img src={TwoTickets} alt="" className="img-fluid" />
                                                        <p>Separate tickets booked together for cheaper price</p>
                                                    </li>
                                                    <li>
                                                        <img src={Travelator} alt="" className="img-fluid" />
                                                        <p>Change of Terminal</p>
                                                    </li>
                                                    <li>
                                                        <img src={Traveler} alt="" className="img-fluid" />
                                                        <p>Self Transfer</p>
                                                    </li>
                                                    <li>
                                                        <img src={Suitcase} alt="" className="img-fluid" />
                                                        <p>7kg</p>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div className="btmNote">
                                                <img src={Traveler} className="img-fluid" alt="" />
                                                <p>Sorry, extra check-in baggage allowance details are not available currently from airline.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="manageBookBox">
                                    <div className="ticketBox">
                                        <div className="leftWraps">
                                            <div className="topTTl">
                                                <h2>Departure Summary</h2>
                                            </div>
                                            <div className="topTtlWrap">
                                                <div className="title">
                                                    <div className="icoWrap"></div>
                                                    <h2>ABC Airline</h2>
                                                </div>
                                                <h6 className="note">Non-refundable</h6>
                                                <p className="classTxt">Travel Class: <span>Economy</span></p>
                                            </div>
                                            <div className="trvelTicWrap">
                                                <div className="leftWrap">
                                                    <ul>
                                                        <li>
                                                            <div className="items">
                                                                <h3>BOM</h3>
                                                                <h5>14.50</h5>
                                                                <p>Sun, 29 Jan 2023</p>
                                                                <p>Maharashtra,India</p>
                                                                <p>Terminal - 2, Gate - 25</p>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div className="items">
                                                                <h4>9hr 50min</h4>
                                                                <div className="planeIcoWrap">
                                                                    <img src={PlaneIco} className="img-fluid" alt="" />
                                                                </div>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div className="items">
                                                                <h3>GOA</h3>
                                                                <h5>14.50</h5>
                                                                <p>Sun, 29 Jan 2023</p>
                                                                <p>Goa, India</p>
                                                                <p>Terminal - 2, Gate - 25</p>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div className="rightWrap">
                                                    <ul>
                                                        <li>
                                                            <p>Buggage</p>
                                                            <h3>ADULT</h3>
                                                        </li>
                                                        <li>
                                                            <p>Check-in</p>
                                                            <h3>23Kgs (1 Piece * 23Kgs)</h3>
                                                        </li>
                                                        <li>
                                                            <p>Cabin</p>
                                                            <h3>7Kgs (1 Piece * 7kgs)</h3>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className="ticketinfoWrap">
                                                <ul>
                                                    <li>
                                                        <img src={TwoTickets} alt="" className="img-fluid" />
                                                        <p>Separate tickets booked together for cheaper price</p>
                                                    </li>
                                                    <li>
                                                        <img src={Travelator} alt="" className="img-fluid" />
                                                        <p>Change of Terminal</p>
                                                    </li>
                                                    <li>
                                                        <img src={Traveler} alt="" className="img-fluid" />
                                                        <p>Self Transfer</p>
                                                    </li>
                                                    <li>
                                                        <img src={Suitcase} alt="" className="img-fluid" />
                                                        <p>7kg</p>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div className="btmNote">
                                                <img src={Traveler} className="img-fluid" alt="" />
                                                <p>Sorry, extra check-in baggage allowance details are not available currently from airline.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="modCancelWrap">
                                        <button className="btn btnMod">Modify</button>
                                        <button className="btn btnBooking" type="button" onClick={handleShow}>Cancel booking</button>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="rightPannelWrap mobRightPannelWrap">
                                    <div className="lowPriceCalWrap">
                                        <div className="lowPriceCal">
                                            <img src={LOWPRICECALENDER} className="img-fluid" alt="" />
                                        </div>
                                        <button className="btn">LOW PRICE CALENDER</button>
                                    </div>
                                    <div className="itemWrap">
                                        <div className="topTTl">
                                            <h2>Tap into the world of travel</h2>
                                        </div>
                                        <div className="imgWrap">
                                            <img src={QRImg} className="img-fluid" alt="" />
                                        </div>
                                        <div className="dataWrap">
                                            <p>Scan the QR code with your device camera and download our app</p>
                                        </div>
                                    </div>
                                    <div className="itemWrap">
                                        <div className="imgWrap">
                                            <img src={giftImg} className="img-fluid" alt="" />
                                        </div>
                                        <div className="dataWrap">
                                            <h2>Log-in and get exclusive discounts!</h2>
                                            <p>Log in and Unlock all the exclusive offers and use wallet etc</p>
                                            <a href="#">Login/Create Account</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer></Footer>


            <Modal show={show} onHide={handleClose} className="CancelBookingPopup">
                <Modal.Header closeButton>
                    <Modal.Title>Select Cancellation Reason</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Could you please specify the reason for your flight cancellation?</p>
                    <Form>
                        <ul className="formList">
                            <li>
                                <div className="inputField selectWrap">
                                    <Form.Select>
                                        <option>Other</option>
                                        <option>Personal Reasons</option>
                                        <option>Health Issues</option>
                                        <option>Travel Restrictions</option>
                                    </Form.Select>
                                </div>
                            </li>
                            <li>
                                <div className="inputField">
                                    <Form.Control as="textarea" placeholder="Provide additional details (optional)" />
                                </div>
                            </li>
                            <li>
                                <div className="ctaWrap">
                                    <Button className="btn" onClick={handleDisclaimerShow}>
                                        Continue
                                    </Button>
                                    <p>Nevermind, I don’t want to cancel.</p>
                                </div>
                            </li>
                        </ul>
                    </Form>
                </Modal.Body>
            </Modal>

            <Modal show={showDisclaimer} onHide={handleDisclaimerClose} className="CancelBookingPopup colSpacePopup">
                <Modal.Header closeButton>
                    <Modal.Title>Disclaimer</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Modification requests are subject to ticket availability and refunds are dependent on airline cancellation policies. Please note that a modification request is not a guarantee of change. Our customer service team will reach out to you with the best possible solution.</p>
                    <div className="btmCtaWrap">
                        <Button onClick={handleCancelAuthShow}>Continue</Button>
                        <p>Nevermind, I don’t want to cancel.</p>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={showCancelBookingAuth} onHide={handleCancelAuthClose} className="CancelBookingPopup colSpacePopup">
                <Modal.Header closeButton>
                    <Modal.Title>Please authenticate yourself by entering the email address linked to the PNR number</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="topDataWrap">
                        <div className="bookingNum">
                            <p>Booking Number</p>
                            <h3>HDX54854215D</h3>
                        </div>
                        <div className="inputWrap">
                            <label>Email/Phone Number</label>
                            <Form.Control type="text" />
                            <p>Invalid email/phone number</p>
                        </div>
                    </div>
                    <div className="btmCtaWrap">
                        <Button onClick={handleProceedToCancelShow}>Continue</Button>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={showProceedToCancel} onHide={handleProceedToCancelClose} className="CancelBookingPopup colSpacePopup">
                <Modal.Header closeButton>
                    <Modal.Title>Please authenticate yourself by entering the OTP linked to the PNR number</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="topDataWrap">
                        <div className="bookingNum">
                            <p>Booking Number</p>
                            <h3>HDX54854215D</h3>
                        </div>
                        <div className="inputWrap">
                            <label>OTP</label>
                            <Form.Control type="text" />
                            <div className="errTxt">
                                <p>Invalid OTP</p>
                                <p className="clrBlack">Resend 00:00</p>
                            </div>
                        </div>
                    </div>
                    <div className="btmCtaWrap">
                        <Link to="/ManageBookingCancel" className="btn">Proceed to Cancel</Link>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}
export default ManageBookingCancel;